module.exports = __webpack_public_path__ + "static/media/everyday_digital_full_crop.59e98a72.png";